import { render, staticRenderFns } from "./custom-rate.vue?vue&type=template&id=4c2603b6&scoped=true"
import script from "./custom-rate.vue?vue&type=script&lang=js"
export * from "./custom-rate.vue?vue&type=script&lang=js"
import style0 from "./custom-rate.vue?vue&type=style&index=0&id=4c2603b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2603b6",
  null
  
)

export default component.exports